import { render, staticRenderFns } from "./CustomSidebar.vue?vue&type=template&id=186d8843&scoped=true"
import script from "./CustomSidebar.vue?vue&type=script&lang=js"
export * from "./CustomSidebar.vue?vue&type=script&lang=js"
import style0 from "./CustomSidebar.vue?vue&type=style&index=0&id=186d8843&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186d8843",
  null
  
)

export default component.exports